// ------------- import external dependencies -------------
import axios from "axios";

/**
 * Separate from the shared instance, and with no interceptor, because the set-password
 * flow is unauthenticated and must not send the Salesforce token.
 */
const VITE_AUTH_API_URL = import.meta.env.VITE_AUTH_API_URL;

export const authApi = axios.create({
  baseURL: VITE_AUTH_API_URL,
});
